import { Colors, Sizes } from "~/jsx/theme";

export const XCardBack = ({
  width,
  onClick,
}: {
  width: number;
  onClick?: () => void;
}) => {
  const { ratio, radius } = Sizes.card;
  const height = width * ratio;
  const isSelectable = Boolean(onClick);
  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: radius,
        width,
        height,
        backgroundImage: "url(/image/card-back.png)",
        backgroundSize: "cover",
        cursor: isSelectable ? "pointer" : "default",
        boxShadow: isSelectable
          ? `${Colors.selection.selectable} 0px 0px 20px 7px`
          : "4px 4px 4px rgba(0, 0, 0, 0.33)",
      }}
    ></div>
  );
};
